<template>
  <div>
    <v-card>
      <view-dialog ref="viewDialog" />
      <v-card-title>
        Seleccionar Cliente
        <v-spacer></v-spacer>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>

            <v-col cols="12" xs="12" lg="11">
              <v-text-field label="Cliente" outlined readonly @keyup.enter.stop @click="showFiterClient = true"
                v-model="selectedClient.name">
                <template v-slot:prepend>
                  <v-icon :disabled="!clientId" color="primary" @click="openView">mdi-eye</v-icon>
                </template>
              </v-text-field>
            </v-col>

            <v-col cols="12" xs="12" lg="1" style="margin-top: 12px">
              <v-btn @click="pickClient({ name: 'Todos' })" style="float: right">Todos</v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>

    <v-dialog v-model="showFiterClient" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="primary" fixed>
          <v-toolbar-title>Procurar Cliente</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon dark @click="showFiterClient = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-container style="margin-top: 20px">
            <v-form ref="searchClientForm" v-model="validForm" lazy-validation @submit.native.prevent>
              <v-row>
                <v-col cols="12" xs="12" lg="10">
                  <v-text-field prepend-inner-icon="search" label="Nome" v-model="searchClientName"
                    :rules="[rules.counter]" clearable @keydown.native.enter="searchClients()"></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" lg="2" style="margin-top: 12px">
                  <v-btn @click="searchClients()" :loading="loadingClients"
                    :disabled="loadingClients || !validateSearchButton()">Procurar</v-btn>
                </v-col>
              </v-row>
            </v-form>

            <v-row>
              <v-col cols="12" v-for="item in clients" :key="item.id" xs="12" sm="6" lg="3">
                <v-card color="grey lighten-3" class="d-flex align-center" @click="pickClient(item)"
                  style="cursor: pointer">
                  <v-card-text>
                    <p style="word-break: break-word">{{ item.name }}</p>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ServiceClient from "@/services/ServiceClient";
import ViewDialog from "@/components/user/ViewDialog";

export default {
  name: "client-picker",
  props: ["selectedClient"],
  components: {
    ViewDialog
  },
  data: () => ({
    validForm: true,
    loadingClients: false,
    searchClientName: "",
    clientId: '',
    clients: [],
    showFiterClient: false,
    rules: {
      counter: (value) => value.length >= 3 || "Min 3 caracteres",
    },
  }),
  watch: {
    searchClientName: "validateSearchButton"
  },
  methods: {
    openView() {
      this.$refs.viewDialog.open(this.clientId);
    },
    validateSearchButton() {
      if (this.searchClientName) {
        if (this.searchClientName.length >= 3) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    async searchClients() {
      if (!this.$refs.searchClientForm.validate()) {
        return;
      }

      this.loadingClients = true;

      try {
        let result;

        if (this.$store.state.user.level == 2) {
          result = await ServiceClient.listAdmin(
            this.searchClientName,
            "",
            "",
            null
          );
        }

        if (this.$store.state.user.level == 1) {
          result = await ServiceClient.list(
            this.searchClientName,
            "",
            "",
            null
          );
        }
        this.clients = result.data;
      } catch (error) {
        this.$store.dispatch("setSnackbar", {
          color: "error",
          text: error,
        });
      }

      this.loadingClients = false;
    },
    pickClient(client) {
      try {
        this.clientId = client.id;
        this.showFiterClient = false;
        this.$emit("pickClient", client);
      } catch (error) {
        this.overlay = false;
        this.$store.dispatch("setSnackbar", {
          color: "error",
          text: error,
        });
      }
    },
  },
  mounted() { },
};
</script>
<style></style>
